import { useState } from '@max/max';
import { RequestStatus, requestDataCenter } from '../utils/request';
export function useRequest() {
    const [data, setData] = useState(null);
    const [requestStatus, setRequestStatus] = useState(RequestStatus.LOADING);
    const request = async (options) => {
        const { onSuccess, onError, onFinally, requestConfig } = options;
        try {
            setRequestStatus(RequestStatus.LOADING);
            const response = await requestDataCenter(requestConfig);
            // 保存响应数据
            setData(response);
            setRequestStatus(RequestStatus.SUCCESS);
            onSuccess?.(response);
        }
        catch (err) {
            const error = err;
            setRequestStatus(RequestStatus.ERROR);
            onError?.(error);
        }
        finally {
            onFinally?.();
        }
    };
    return {
        data,
        requestStatus,
        request,
        setData,
        isLoading: requestStatus === RequestStatus.LOADING,
        isSuccess: requestStatus === RequestStatus.SUCCESS,
        isError: requestStatus === RequestStatus.ERROR
    };
}
